// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"c3001d86","currentOrgName":"d7572f8d","selectGeneral":"a371a05a","djangoAdmin":"c712f727"};